<app-upsell-card
  htmlTitle="<strong>Important:</strong> Boost Recovery & Blood Flow with Peptide Therapy"
  question="Would you like to add Peptide Therapy for the most complete results?"
  [slug]="slug"
  [options]="options"
>
  <ng-content></ng-content>
</app-upsell-card>
